(function () {
'use strict';
var $  = function (sel, ctx) { return (ctx || document).querySelector(sel); };
var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }
function money(cents, format) {
var amount = (cents / 100);
var str = amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
if (format && format.indexOf('{{amount}}') === -1) { return str; }
return (format || '{{amount}} \u20ac').replace('{{amount}}', str);
}
function initAccordions(root) {
$$('[data-rlx-acc-trigger]', root).forEach(function (btn) {
on(btn, 'click', function () {
var acc = btn.closest('[data-rlx-acc]');
if (!acc) return;
var open = acc.classList.toggle('is-open');
btn.setAttribute('aria-expanded', open ? 'true' : 'false');
});
});
}
function ProductController(scope) {
var dataEl = $('[data-rlx-product]', scope) || $('[data-rlx-product]');
if (!dataEl) return null;
var data;
try { data = JSON.parse(dataEl.textContent); } catch (e) { return null; }
var state = {
options: (data.initialOptions || []).slice(),
variant: null,
qty: 1,
imageIndex: 0
};
function findVariant(opts) {
return (data.variants || []).find(function (v) {
return v.options.every(function (o, i) { return o === opts[i]; });
}) || null;
}
function variantAvailableForOption(optIndex, value) {
var probe = state.options.slice();
probe[optIndex] = value;
return (data.variants || []).some(function (v) {
var match = v.options.every(function (o, i) {
if (i === optIndex) return o === value;
return o === probe[i];
});
return match && v.available;
});
}
var priceNowEls = $$('[data-rlx-price-now]');
var priceWasEls = $$('[data-rlx-price-was]');
var atcButtons  = $$('[data-rlx-atc]');
var variantInputs = $$('[data-rlx-variant-id]');
var colorLabelEls = $$('[data-rlx-color-value]');
var sizeLabelEls  = $$('[data-rlx-size-value]');
function syncUI() {
var v = state.variant;
var available = v && v.available;
if (v) {
priceNowEls.forEach(function (el) { el.textContent = money(v.price, data.moneyFormat); });
priceWasEls.forEach(function (el) {
if (v.compare_at_price && v.compare_at_price > v.price) {
el.style.display = '';
el.textContent = money(v.compare_at_price, data.moneyFormat);
} else { el.style.display = 'none'; }
});
}
variantInputs.forEach(function (input) { if (v) input.value = v.id; });
atcButtons.forEach(function (btn) {
btn.disabled = !available;
var addLbl = btn.getAttribute('data-label-add');
var soldLbl = btn.getAttribute('data-label-soldout');
if (addLbl || soldLbl) {
btn.textContent = available ? (addLbl || btn.textContent) : (soldLbl || 'Agotado');
}
});
colorLabelEls.forEach(function (el) { if (state.options[el.getAttribute('data-rlx-color-value')] || state.options[0]) el.textContent = state.options[Number(el.dataset.optIndex || 0)]; });
sizeLabelEls.forEach(function (el) { var i = Number(el.dataset.optIndex || 1); if (state.options[i]) el.textContent = state.options[i]; });
$$('[data-rlx-sticky-variant]').forEach(function (el) { el.textContent = state.options.join(' / '); });
$$('[data-rlx-sticky-now]').forEach(function (el) { if (v) el.textContent = money(v.price, data.moneyFormat); });
$$('[data-rlx-sticky-was]').forEach(function (el) {
if (v && v.compare_at_price && v.compare_at_price > v.price) { el.style.display=''; el.textContent = money(v.compare_at_price, data.moneyFormat); }
else { el.style.display = 'none'; }
});
if (v && v.featured_image_index != null) { setImage(v.featured_image_index); }
}
function bindOptionButtons() {
$$('[data-rlx-option]').forEach(function (btn) {
var idx = Number(btn.getAttribute('data-rlx-option'));
var val = btn.getAttribute('data-rlx-value');
on(btn, 'click', function () {
if (btn.disabled) return;
state.options[idx] = val;
state.variant = findVariant(state.options);
$$('[data-rlx-option]').forEach(function (b) {
if (Number(b.getAttribute('data-rlx-option')) === idx) b.classList.toggle('is-active', b === btn);
});
refreshAvailability();
var grp = btn.closest('[data-rlx-option-group]');
if (grp) {
var lbl = $('[data-rlx-option-label]', grp);
if (lbl) lbl.textContent = val;
}
syncUI();
});
});
}
function refreshAvailability() {
$$('[data-rlx-option]').forEach(function (btn) {
var idx = Number(btn.getAttribute('data-rlx-option'));
if (idx === 0) return; // colour always selectable
var val = btn.getAttribute('data-rlx-value');
var ok = variantAvailableForOption(idx, val);
btn.disabled = !ok;
});
}
function setImage(i) {
state.imageIndex = i;
$$('[data-rlx-gallery-main]').forEach(function (img) {
var src = img.getAttribute('data-src-' + i);
if (src) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src; }
});
$$('[data-rlx-dot]').forEach(function (d) {
d.classList.toggle('is-active', Number(d.getAttribute('data-rlx-dot')) === i);
});
$$('[data-rlx-thumb]').forEach(function (t) {
t.classList.toggle('is-active', Number(t.getAttribute('data-rlx-thumb')) === i);
});
}
function galleryCount() {
var main = $('[data-rlx-gallery-main]');
if (!main) return 0;
var n = 0;
while (main.getAttribute('data-src-' + n) != null) { n++; }
return n;
}
function bindGallery() {
$$('[data-rlx-thumb]').forEach(function (t) {
on(t, 'click', function () { setImage(Number(t.getAttribute('data-rlx-thumb'))); });
});
$$('[data-rlx-dot]').forEach(function (d) {
on(d, 'click', function () { setImage(Number(d.getAttribute('data-rlx-dot'))); });
});
$$('[data-rlx-gallery-main]').forEach(function (img) {
var count = galleryCount();
if (count < 2) return;
var startX = null;
on(img, 'touchstart', function (e) { startX = e.changedTouches[0].clientX; });
on(img, 'touchend', function (e) {
if (startX == null) return;
var dx = e.changedTouches[0].clientX - startX;
if (Math.abs(dx) > 30) {
var next = dx < 0 ? state.imageIndex + 1 : state.imageIndex - 1;
if (next < 0) next = count - 1;
if (next >= count) next = 0;
setImage(next);
}
startX = null;
});
on(img, 'click', function () {
var next = state.imageIndex + 1;
if (next >= count) next = 0;
setImage(next);
});
});
}
function bindQty() {
$$('[data-rlx-qty]').forEach(function (wrap) {
var valEl = $('[data-rlx-qty-val]', wrap);
on($('[data-rlx-qty-dec]', wrap), 'click', function () {
state.qty = Math.max(1, state.qty - 1); if (valEl) valEl.textContent = state.qty;
});
on($('[data-rlx-qty-inc]', wrap), 'click', function () {
state.qty = state.qty + 1; if (valEl) valEl.textContent = state.qty;
});
});
}
function bindAddToCart() {
$$('[data-rlx-atc]').forEach(function (btn) {
on(btn, 'click', function (e) {
if (!state.variant) return;
var form = btn.closest('form');
if (form && !btn.hasAttribute('data-rlx-ajax')) return; // native submit
e.preventDefault();
btn.disabled = true;
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ id: state.variant.id, quantity: state.qty })
})
.then(function (r) { return r.json(); })
.then(function () {
document.dispatchEvent(new CustomEvent('rlx:cart:added', { detail: { variant: state.variant, qty: state.qty } }));
window.location.href = '/cart';
})
.catch(function () { if (form) form.submit(); })
.finally(function () { btn.disabled = false; });
});
});
}
state.variant = findVariant(state.options) || (data.variants || [])[0] || null;
if (state.variant) state.options = state.variant.options.slice();
bindOptionButtons();
bindGallery();
bindQty();
bindAddToCart();
refreshAvailability();
syncUI();
return { state: state };
}
function initDesktopHero() {
if (!('matchMedia' in window)) return;
var mq = window.matchMedia('(min-width: 1100px)');
var gallery = $('.rlx-gallery');
if (!gallery) return;
var gallerySection = gallery.closest('.rlx-shopify-section, .shopify-section');
if (!gallerySection || !gallerySection.parentNode) return;
var parent = gallerySection.parentNode;
var BOUNDARY = '.rlx-reviews__head, .rlx-thumbs, .rlx-strip, .rlx-banner,' +
'.rlx-community, .rlx-testi, .rlx-cards, .rlx-faq__title, .rlx-sticky';
var built = false;
function isSection(node) {
return node && node.classList &&
(node.classList.contains('rlx-shopify-section') || node.classList.contains('shopify-section'));
}
function build() {
if (built) return;
var rights = [];
var node = gallerySection.nextElementSibling;
while (node) {
if (isSection(node) && node.querySelector && node.querySelector(BOUNDARY)) break;
if (isSection(node)) rights.push(node);
node = node.nextElementSibling;
}
if (!rights.length) return;
var hero  = document.createElement('div'); hero.className  = 'rlx-hero2';
var left  = document.createElement('div'); left.className  = 'rlx-hero2__left';
var right = document.createElement('div'); right.className = 'rlx-hero2__right';
parent.insertBefore(hero, gallerySection);
hero.appendChild(left);
hero.appendChild(right);
left.appendChild(gallerySection);
rights.forEach(function (s) { right.appendChild(s); });
built = true;
}
function teardown() {
if (!built) return;
var hero = parent.querySelector(':scope > .rlx-hero2') || parent.querySelector('.rlx-hero2');
if (!hero) { built = false; return; }
var right = hero.querySelector('.rlx-hero2__right');
parent.insertBefore(gallerySection, hero);
if (right) {
Array.prototype.slice.call(right.children).forEach(function (s) {
parent.insertBefore(s, hero);
});
}
parent.removeChild(hero);
built = false;
}
function apply() { if (mq.matches) build(); else teardown(); }
apply();
if (mq.addEventListener) mq.addEventListener('change', apply);
else if (mq.addListener) mq.addListener(apply);
}
function initSticky() {
var sticky = $('[data-rlx-sticky]');
var anchor = $('[data-rlx-atc-anchor]');
if (!sticky) return;
if (!('IntersectionObserver' in window) || !anchor) { sticky.classList.add('is-visible'); return; }
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (en) {
sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
});
}, { threshold: 0 });
io.observe(anchor);
}
function boot() {
initAccordions(document);
ProductController(document);
initDesktopHero();
initSticky();
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
else { boot(); }
document.addEventListener('shopify:section:load', function (e) {
initAccordions(e.target);
ProductController(document);
initSticky();
});
})();